// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delMsg {
  font-size: 16px;
  margin: 10px;
}
.errMsg {
  font-size: 16px;
  margin: 10px;
  color: "red";
}
.btnContainer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/components/survey/styles/DeleteView.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B","sourcesContent":[".delMsg {\n  font-size: 16px;\n  margin: 10px;\n}\n.errMsg {\n  font-size: 16px;\n  margin: 10px;\n  color: \"red\";\n}\n.btnContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
